import { render, staticRenderFns } from "./historicalExp.vue?vue&type=template&id=60af380e&scoped=true"
import script from "./historicalExp.vue?vue&type=script&lang=js"
export * from "./historicalExp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60af380e",
  null
  
)

export default component.exports